export default {

  setUsers(state, data) {
    state.users = data;
  },

  setUser(state, data) {
    state.user = data;
  },

  setDynamicPageContent(state, data) {
    state.dynamicPageContent = data;
  },

};
